import React from 'react';
//import 'bootstrap/dist/css/bootstrap.css';
//import 'bootstrap/dist/css/bootstrap-theme.css';
import { Home } from './components/Home';
import { Switch, BrowserRouter as Router } from 'react-router-dom';
import { Admin } from './components/Admin';
import AuthRouteWrapper from './AuthRouteWrapper';
import { MsalProvider } from '@azure/msal-react';
import { Admin1 } from './components/Admin';
import { Route } from 'react-router-dom/cjs/react-router-dom';
import { msalInstance } from './msalConfig';

const App = () => {
  return (

    <Router>
     
     {/* <MsalProvider instance={msalInstance}>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route exact path="/admin" component={Admin1} />
       
        </Switch>
      </MsalProvider> */}
      <MsalProvider instance={msalInstance}>
      <Switch>
      
       <AuthRouteWrapper
          exact path="/" component={Home} isPrivate={false} 
        />
        <AuthRouteWrapper
          exact path="/admin" component={Admin} isPrivate={true}/>
          
         </Switch>
         </MsalProvider>
         
    </Router>
  ); 
};







// const App = () => {
  
// const accounts1 = msalInstance.getAllAccounts();
// console.log("accounts", accounts1);
// if (accounts1.length > 0) {
//   msalInstance.setActiveAccount(accounts1[0]);
// }

// msalInstance.addEventCallback((event) => {
//   if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
//     console.log("success",event.payload.account)
//     const account = event.payload.account;
//     msalInstance.setActiveAccount(account);
//   }

//   if (event.eventType === EventType.LOGIN_FAILURE) {
//     console.log("Failure",event.eventType);
//     console.log(JSON.stringify(event));
//   }
// });
// msalInstance.handleRedirectPromise().then(authResult=>{
//     debugger;
//     console.log(authResult);
//     const account = msalInstance.getActiveAccount();
//     // msalInstance.acquireTokenSilent({...loginRequest,account: accounts[0]}).then((response) => {
//     //     console.log("Resonse", response)
//     //     callMsGraph(response.accessToken).then((response)=>{
//     //         console.log(response.accessToken)
//     //     })
//     // })
//     console.log("account",account)
//     if(!account){
//         console.log("!account",!account)
//       // redirect anonymous user to login page 
//       msalInstance.loginRedirect();
//     }
//   }).catch(err=>{
//        console.log("Error",err);
//   });
//   const isAuthenticated = useIsAuthenticated();
//   const { instance, inProgress, accounts } = useMsal();
//   const account = useAccount(accounts[0] || {});
//   useEffect(() => {
//     if (inProgress === InteractionStatus.None && !isAuthenticated) {
//       instance.loginRedirect(loginRequest);
//       console.log("User Authencticated");
//     }
//   });
//   return (
//     <div>
      
//       <Route path="/" component={Home} />
//       <ProtectedRoute exact path="/admin" component={Admin} />
        
//         {/* <AuthenticatedTemplate>
//            <Route path="/admin" component={Admin} />
//         </AuthenticatedTemplate> */}
//          </div>
//          );
// };






export default App;